<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import { fromDraggableNodes, toDraggableNodes } from '@/utils/draggable-parse'

const props = defineProps<{
  context: FormKitFrameworkContext
}>()

const nodes = computed({
  get() {
    return toDraggableNodes(props.context.value)
  },
  set(v) {
    return props.context.node.input(fromDraggableNodes(v))
  },
})
</script>
<template>
  <div :class="context.help && 'flex-col'">
    <FormRichRepeater
      v-model:nodes="nodes"
      :schema="context.attrs.props.innerSchema"
      :node-component="context.attrs.props.nodeComponent"
    />
  </div>
</template>
